exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".billing-details-container,.shipping-details.container{width:50%}@media (max-width:768px){.billing-details-container,.shipping-details.container{width:100%}}.lazyload{width:200px;height:auto}@media (max-width:768px){.lazyload{width:100px;height:auto}}.accept-label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 0 15px;margin-bottom:0}.accept-label input{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b07f3bf2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/modulatte-cart/components/Payment.vue
// module id = pRJo
// module chunks = 1